export default "__VITE_ASSET__BRSwa2Cb__"